import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { PagingModule } from '../../components/common/search/paging.module';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'ngx-tooltip';
import { BlockUIModule } from 'ng-block-ui';
import { MyMatchesComponent } from './my.matches.component';
import { TenderSearchComponent } from './search.component';
import { DebounceModule } from '../../components/common/debounce/debounce.module';
import { MyDatePickerModule } from 'mydatepicker';
import { DeleteModalModule } from '../../components/common/deletemodal/delete.modal.module';
import { AuthModule } from '../../auth/auth.module';
import { TenderResultsComponent } from './results.component';
import { CategoryTreeViewModule } from '../../components/common/category.tree.view/category.tree.view.module';
import { NoticesModule } from '../notices/notices.module';
import { B2BAngularMaterialModule } from '../../components/common/angular.material/b2b.angular.material.module';
import { DateRangeModule } from '../../components/common/date.range/date.range.module';
import { MomentPipeModule } from '../../components/pipes/moment.pipe/moment.pipe.module';
import { HttpPrefixPipeModule } from '../../components/pipes/httpprefix.pipe/http.prefix.pipe.module';
import { SentToBidManagementComponent } from './sent.to.bid.management.component';
import { PrintTenderComponent } from './print.component';
import { TendersBookmarkedComponent } from './bookmarked.component';
import { SafeHtmlPipeModule } from '../../components/pipes/safehtml.pipe/safe.html.pipe.module';
import { MatchesWithIdComponent } from './matches.with.id.component';
import { TendersSharedBookmarkedComponent } from './shared.bookmarked.component';
import { TendersBookmarksComponent } from './bookmarks.component';
import { TendersAssignedComponent } from './assigned.component';
import { TendersSearchWithIdComponent } from './search.with.id.component';

@NgModule({
    declarations: [
        MyMatchesComponent, TenderSearchComponent, TenderResultsComponent, SentToBidManagementComponent,
        PrintTenderComponent, TendersBookmarkedComponent, MatchesWithIdComponent, TendersSharedBookmarkedComponent, TendersAssignedComponent,
        TendersBookmarksComponent, TendersSearchWithIdComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        PagingModule,
        RouterModule,
        TooltipModule,
        DebounceModule,
        MyDatePickerModule,
        DeleteModalModule,
        AuthModule,
        CategoryTreeViewModule,
        BlockUIModule,
        NoticesModule,
        B2BAngularMaterialModule,
        DateRangeModule,
        MomentPipeModule,
        HttpPrefixPipeModule,
        SafeHtmlPipeModule
    ]
})

export class TendersModule { }


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/tenders/tenders.module.ts